import script from "./GuideNewView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideNewView.vue?vue&type=script&setup=true&lang=ts"

import "./GuideNewView.vue?vue&type=style&index=0&id=94b45394&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.25+webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b45394"]])

export default __exports__